import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogHeader, DialogTitle, } from '@cargomatic/ui';
import { withTranslation } from 'react-i18next';
import QuoteForm from './QuoteForm';
class QuoteModal extends Component {
    constructor() {
        super(...arguments);
        this.handleHide = () => {
            this.props.onHide();
        };
    }
    render() {
        const { show, quote, t } = this.props;
        const title = quote && quote.quote_id
            ? t('EDIT_QUOTE_WITH_VALUE', { editQuote: quote.quote_id })
            : t('GET_A_QUOTE');
        return (React.createElement(Dialog, { open: show, onOpenChange: this.handleHide },
            React.createElement(DialogContent, { className: "w-screen h-screen max-w-none max-h-none overflow-y-auto" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null, title)),
                React.createElement(QuoteForm, { onCancel: this.handleHide, shipper: this.props.shipper, quote: this.props.quote }))));
    }
}
QuoteModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    quote: PropTypes.object,
    shipper: PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
    }),
};
export default withTranslation()(QuoteModal);
